export default "__VITE_ASSET__BCP0KbHJ__"